// extracted by mini-css-extract-plugin
module.exports = {"roundedButton":"_1aWMFgwMVmCKLK_NrP6D1i"};